<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XlAdCs/CoverDesign.jpg?1685204506186" alt="This image is the cover for the book Like No One Is Watching, Dance, Love, Live"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Like No One Is Watching, Dance, Love, Live
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Dance, Love, Live: Book One</i></b></p><p>Dusty has finally landed a job he thinks he’ll be able to keep long-term, even with his broken brain and bum knee. He didn’t anticipate that cleaning a dance studio would reawaken his yearning to dance—even though he is no longer capable—or that meeting the studio’s director would rouse his dormant libido. Or his sleeping heart.</p><p>Conrad thinks his life is finally complete with his successful dance studio and a steady stream of students. When Dusty arrives, he rediscovers his thirst for a man who will let him hand over control and give him the undivided attention he’s never had. The trouble is, Dusty isn’t sure he’s worthy of the studio director’s submission.</p><p>To make their relationship work, Dusty will have to trust his ability to dominate the powerful and beautiful dancer, and Conrad will have to stop talking long enough to hear Dusty’s promises.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jaime Samms
      </h2>
      
      <p class="authorDescription body article"><P>Lost. Broken. Found&hellip; loved. Romance for all.</P><P>Jaime Samms is a plaid-hearted Canadian who spends the too-long winters writing stories about love between men and the too-short summers digging in the garden. There are dust bunnies in the corners of her house&mdash;which she blames on a husky named Kai. There are dishes on the counter&mdash;which is clearly because teenagers! There is hot coffee in the pot and the occasional meal to keep her from starving&mdash;because her husband is remarkable and patient.</P><P>A multipublished author whose work has been translated into French, Italian, and German, Jaime delights in the intricate dance of words that leads her through tales of the lost and brokenhearted men she writes about to the love stories that find and mend them.</P><P>And when the muse is being stubborn, she also makes pretty things with yarn and fabric scraps because in her world, no heart is too broken to love, and nothing is too worn or tired it can&rsquo;t be upcycled into something beautiful. All it takes is determination and the ability to see life a little bit left of center.</P><P>Website: jaime-samms.com</P><P>Facebook: www.facebook.com/profile.php?id=100000982219151&amp;ref=tn_tnmn</P><P>Deviantart: dontkickmycane.deviantart.com</P><P>Twitter: @JaimeSamms</P><P>Amazon Author page: www.amazon.com/author/jaimesamms</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94c97d8c